module.exports = __webpack_public_path__ + "img/cloneManagerDialog.b788bb0e.jpg";